import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import moment from 'moment';
import { checkEmail } from '@/utils/validate';
export default {
  methods: {
    generateValidateRule(control) {
      const rules = [];
      if (control.attributeVerification === 'PHONE') {
        rules.push({
          validator: this.validatePhone,
          trigger: 'blur'
        });
      }
      if (control.attributeVerification === 'IDCODE') {
        rules.push({
          validator: this.validateIdCard,
          trigger: 'blur'
        });
      }
      const validateEnclosure = (rule, value, callback) => {
        let files = this.formData[control.mark];
        if (!files || files.length === 0) {
          callback(new Error(this.$t('请上传附件')));
        } else {
          callback();
        }
      };
      if (control.attributeVerification === 'email') {
        rules.push({
          validator: this.validateEmail,
          message: this.$t('请输入有效的邮箱地址'),
          trigger: 'blur'
        });
      }
      if (control.attributeVerification === 'NUMBER') {
        rules.push({
          pattern: /^\d+(\.\d+)?$/,
          message: this.$t('请输入数字'),
          trigger: 'blur'
        });
        // 校验小数点
        rules.push({
          validator: (rule, value, callback) => {
            if (value) {
              var _String;
              let decimalPlaces = value === null || value === void 0 ? void 0 : value.split('.')[1];
              let len = (value === null || value === void 0 ? void 0 : value.split('.').length) > 1 ? (_String = String(decimalPlaces)) === null || _String === void 0 ? void 0 : _String.split('').length : 0;
              let msg = this.$t('最多只能输入带有0位小数的数值').replace('0', control.decimalPlaces);
              if (len > control.decimalPlaces) {
                callback(new Error(msg));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: 'blur'
        });
      }
      const validateEmptySingleRequired = (rule, value, callback) => {
        let controlValue = this.formData[control.mark];
        let status = true;
        control.controlValue && Array.isArray(control.controlValue) && control.controlValue.forEach((item, index) => {
          console.log(item.name, controlValue, item.isWrite);
          if (!item.emptyValue && item.isWrite && controlValue && item.name === controlValue) {
            status = false;
          }
        });
        if (!status && control.controlValue) {
          callback(new Error(`${this.$t('请选择')}${control.controlName}`));
        } else {
          callback();
        }
      };
      const validateEmptyMultiplyRequired = (rule, value, callback) => {
        let controlValue = this.formData[control.mark];
        let status = true;
        control.controlValue.forEach((item, index) => {
          if (!item.emptyValue && item.isWrite && controlValue && controlValue.indexOf(item.name) !== -1) {
            status = false;
          }
        });
        if (!status && controlValue.length > 0) {
          callback(new Error(`${this.$t('请选择')}${control.controlName}`));
        } else {
          callback();
        }
      };
      if (control.partsType === 'singleChoice') {
        rules.push({
          validator: validateEmptySingleRequired,
          trigger: 'change'
        });
      } else if (control.partsType === 'multipleChoice') {
        rules.push({
          validator: validateEmptyMultiplyRequired,
          trigger: 'change'
        });
      }
      // 是否必填校验
      if (control.isRequired) {
        if (
        // control.partsType === 'singleChoice' ||
        // control.partsType === 'multipleChoice' ||
        control.partsType === 'date') {
          rules.push({
            required: true,
            message: `${this.$t('请选择')}${control.controlName}`,
            trigger: 'change'
          });
        } else if (control.partsType === 'enclosure') {
          rules.push({
            required: true,
            validator: validateEnclosure,
            trigger: 'blur'
          });
        } else if (control.partsType === 'dropDown') {
          rules.push({
            required: true,
            message: `${this.$t('请选择')}${control.controlName}`,
            trigger: 'blur'
          });
        } else {
          rules.push({
            required: true,
            message: `${this.$t('请输入')}${control.controlName}`,
            trigger: 'blur'
          });
        }
      }
      const validateMultipleChoice = (rule, value, callback) => {
        const [min, max] = control.numberLimit.split(',');
        let multipleValue = this.formData[control.mark];
        if (multipleValue && multipleValue.length > parseInt(max)) {
          let msg = this.$t('最多只能选择0个').replace('0', max);
          callback(new Error(this.$t(`${msg}${control.controlName}`)));
        } else if (multipleValue && multipleValue.length < parseInt(min)) {
          let msg = this.$t('最少也要选择0个').replace('0', min);
          callback(new Error(this.$t(`${msg}${control.controlName}`)));
        } else {
          callback();
        }
      };
      if (control.numberLimit) {
        // console.log('-----limit------', control.value.length);
        const [min, max] = control.numberLimit.split(',');
        if (control.partsType === 'multipleChoice') {
          rules.push({
            validator: validateMultipleChoice,
            trigger: 'blur'
          });
        } else {
          let msg = this.$t('长度在0到1个字符').replace('0', min).replace('1', max);
          rules.push({
            min: parseInt(min),
            max: parseInt(max),
            message: msg,
            trigger: 'blur'
          });
        }
      }
      return rules;
    },
    setAssociationInfo(control) {
      var _controlItem$associat;
      //设置关联关系
      let mark = control.controlType === 'control' ? control.control.mark : control.mark;
      let controlItem = control.controlType === 'control' ? control.control : control;
      if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
        let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
        let value = controlItem.association.association[0];
        value.targetKey = mark;
        if (Array.isArray(this.associationInfo[key])) {
          this.associationInfo[key].push(value);
        } else {
          this.associationInfo[key] = [value];
        }
        this.$set(this.showControl, mark, false);
      } else {
        this.$set(this.showControl, mark, true);
      }
    },
    setEchoForm(controlItem) {
      //设置表单回显值
      if (controlItem.partsType === 'multipleChoice') {
        let value = controlItem.value || [];
        this.$set(this.formData, controlItem.mark, value);
      } else if (controlItem.partsType === 'dropDown') {
        let valueObj = controlItem.value;
        let value = valueObj ? valueObj.codeValue : undefined;
        this.$set(this.formData, controlItem.mark, value);
      } else {
        this.$set(this.formData, controlItem.mark, controlItem.value || undefined);
      }
    },
    handleControlValue(controlItem) {
      //处理控件的value值
      if (controlItem.partsType === 'dropDown') {
        let value = this.formData[controlItem.mark];
        controlItem.value = this.handleDropDownData(value, controlItem);
        delete controlItem.dataList; //去掉dataList
      } else if (controlItem.partsType === 'date') {
        //日期组件处理格式
        let value = this.formData[controlItem.mark];
        controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
      } else if (controlItem.partsType !== 'table') {
        controlItem.value = this.formData[controlItem.mark] || '';
      }
      controlItem.mark = controlItem.mark.replace('d_', 'd.');
    },
    validatePhone(rules, value, callback) {
      let pattern = /^1[0-9]{10}$/;
      if (value && !pattern.test(value.trim())) {
        callback(new Error(this.$t('请输入有效的手机号码')));
      } else {
        callback();
      }
    },
    validateEmail(rules, value, callback) {
      if (value && !checkEmail(value)) {
        callback(new Error(this.$t('邮箱格式有误，请重新填写')));
      }
      callback();
    },
    validateIdCard(rules, value, callback) {
      let pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value && !pattern.test(value.trim())) {
        callback(new Error(this.$t('请输入有效的身份证号码')));
      } else {
        callback();
      }
    }
  }
};